module.exports = __webpack_public_path__ + "static/media/profile.35ef1169.svg";